<template>
  <div>
    <!-- <market-bar></market-bar> -->
    <iframe
      style="width:100%;position: absolute; top: 60px; border-top: 1px solid #f5f5f5"
      :src="loginUrl"
      scrolling="no"
      frameborder="0"
      name="ifd"
      :height="$route.params.type === 'console' ? '1000' : '1700'"
    ></iframe>
  </div>
</template>
<script type="text/javascript">
// function setIframeHeight(iframe) {
//   if (iframe) {
//     var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow
//     if (iframeWin.document.body) {
//       iframe.height =
//         iframeWin.document.documentElement.scrollHeight ||
//         iframeWin.document.body.scrollHeight
//     }
//   }
// }
// import MarketBar from "@/views/frontViews/components/marketBar"
export default {
  components: {
    // Topbar
    // MarketBar
  },
  data() {
    return {
      loginUrl: localStorage.getItem("login_url")
    }
  },
  created() {
    console.log(this.$route.params.type)
  },
  mounted() {},

  computed: {},

  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/cooperate.vue